import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CardContainerModule } from '@go-modules/components/card-container/card-container.module';
import { CommentIndicatorModule } from '@go-modules/components/comment-indicator/comment-indicator.module';
import { DotIndicatorModule } from '@go-modules/components/dot-indicator/dot-indicator.module';
import { MenuModule } from '@go-modules/components/menus/menu/menu.module';
import { OutsideClickModule } from '@go-modules/directives/outside-click';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FolderMenuModule } from '@go-modules/components/menus/folder-menu/folder-menu.module';
import { FolderCardComponent } from './folder-card.component';
import { BadgeModule } from '@go-modules/components/badge/badge.module';
import { FormatDateModule } from '@go-modules/pipes/format-date/format-date.module';
import { DetectTextTruncationDirective } from '@go-modules/directives/truncate/detect-text-truncation.directive';

@NgModule({
	imports: [
		CommonModule,
		GoMaterialModule,
		CardContainerModule,
		DotIndicatorModule,
		FolderMenuModule,
		TranslateModule,
		OutsideClickModule,
		MenuModule,
		CommentIndicatorModule,
		BadgeModule,
		FormatDateModule,
		DetectTextTruncationDirective
	],
	declarations: [
		FolderCardComponent
	],
	exports: [
		FolderCardComponent
	]
})
export class FolderCardModule {}
